import React, {useEffect, useState} from "react";
import "../../../styles/component/employee/employee-search.scss"
import {getName} from "../../../utility/utility";
import server from "../../../server";
import EmployeeSearchView from "./employee-search.view";
import {SearchParams} from "../../common/search-criteria/type/search-criteria.type";
import {IDesignationEnum, IEmployee} from "./utils/interface";

function EmployeeSearch() {
    const [employeeResponse, setEmployeeResponse] = useState<IEmployee[]>([]);
    const [designation, setDesignation] = useState<IDesignationEnum[]>([]);
    const [isActiveEmployees, setIsActiveEmployees] = useState(true);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [headingChange, setHeadingChange] = useState(false);
    const [appliedActiveStatus, setAppliedActiveStatus] = useState(true);
    const [sortField, setSortField] = useState("CREATED_ON");
    const [sortDirection, setSortDirection] = useState<"ASC" | "DESC"|undefined>("DESC");
    const pageSize = 11;
    const [searchPayload, setSearchPayload] = useState<any>({
        active: true,
        sortBy:sortField,
        sortDirection:sortDirection
    });

    useEffect(() => {
        fetchDesignationData();
    }, []);

    useEffect(() => {
        fetchEmployees(searchPayload, pageNumber);
    }, [pageNumber]);

    const handleNextPage = () => {
        setPageNumber(prev => prev + 1);
    };

    const handlePrevPage = () => {
        if (pageNumber > 0) {
            setPageNumber(prev => prev - 1);
        }
    };

    const fetchDesignationData = async () => {
        try {
            const resp: any = await server.settings.designation.list();
            resp.unshift({
                id: '-Select-',
                code: '-Select-',
                description: '-Select-',
                active: false
            });
            setDesignation(resp);
        } catch (error) {
            console.log(error);
        }
    };

    // const searchCriteria=async()=>{
    //     const resp = await server.employee.search(
    //         payload,
    //         pageSize,
    //         page,
    //         "CREATED_ON",   // 👈 enum value from backend
    //         "DESC"
    //     );
    // }

    const fetchEmployees = async (payload: any, page: number) => {
        setLoading(true);
        try {
            const resp = await server.employee.search(
                payload,
                pageSize,
                page,
                // sortField,       // ✅ added
                // sortDirection    // ✅ added
            );
            const formatted = resp.map((employee: any, index: number) => ({
                ...employee,
                employeeName: getName(
                    employee.name.firstName,
                    employee.name.middleName,
                    employee.name.lastName
                ),
                designation: employee?.designation?.displayName,
                key: index
            }));
            setEmployeeResponse(formatted);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const handleSortChange = (field: string, direction: "ASC" | "DESC"|undefined) => {
        setSortField(field);
        setSortDirection(direction);



        const search={...searchPayload,sortBy:field,sortDirection:direction};

        setSearchPayload(search);

        fetchEmployees(search, pageNumber);
    };

    const toggleActiveAndInactiveEmployees = (value: boolean) => {
        setIsActiveEmployees(value);
    };

    const handleReset = () => {
        const payload = {
            active: true,
            sortBy:sortField,
            sortDirection:sortDirection
        };
        setHeadingChange(false);
        setPageNumber(0);
        setIsActiveEmployees(true);
        setAppliedActiveStatus(true);
        setSearchPayload(payload);
        fetchEmployees(payload, 0);
    };

    const handleSearch = async (params: SearchParams) => {
        setHeadingChange(true);
        const payload: any = {
            active: isActiveEmployees,
            sortBy:sortField,
            sortDirection:sortDirection,
            countryCode: params.mobile?.countryCode,
            mobileNumber: params.mobile?.mobileNumber,
            ...params,
            mobile: undefined
        };

        if (params.joiningDate && Array.isArray(params.joiningDate)) {
            const [startDate, endDate] = params.joiningDate;
            payload.joiningDate = {
                startDate: startDate || null,
                endDate: endDate || null
            };
        }

        setAppliedActiveStatus(isActiveEmployees);
        setSearchPayload(payload);
        setPageNumber(0);
        fetchEmployees(payload, 0);
    };

    return (
        <EmployeeSearchView
            appliedActiveStatus={appliedActiveStatus}
            isActiveEmployees={isActiveEmployees}
            toggleActiveAndInactiveEmployees={toggleActiveAndInactiveEmployees}
            pageNumber={pageNumber}
            pageSize={pageSize}
            employeeResponse={employeeResponse}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            handleSearch={handleSearch}
            onSortChange={handleSortChange}
            handleReset={handleReset}
            headingChange={headingChange}
            loading={loading}
            sortField={sortField}
            sortDirection={sortDirection}
        />
    );
}

export default EmployeeSearch;
